const topicItems = [
  { id: 1, label: '午夜专场', heat: '🔥 86.2万讨论', href: '#ranking' },
  { id: 2, label: '香蕉视频新片', heat: '🔥 72.5万讨论', href: '#ranking' },
  { id: 3, label: '红桃视频悬疑', heat: '📈 58.3万关注', href: '#ranking' },
  { id: 4, label: '蜜桃视频精选', heat: '🔥 51.7万讨论', href: '#ranking' },
  { id: 5, label: '樱花综艺', heat: '📈 44.9万关注', href: '#ranking' },
  { id: 6, label: '动作猛片合集', heat: '🔥 39.6万讨论', href: '#ranking' },
  { id: 7, label: '烧脑推理剧', heat: '📈 33.2万关注', href: '#ranking' },
  { id: 8, label: '经典港片重映', heat: '🆕 28.5万关注', href: '#ranking' },
  { id: 9, label: '动漫追番指南', heat: '🔥 24.1万讨论', href: '#ranking' },
  { id: 10, label: '高清修复专区', heat: '📈 19.8万关注', href: '#ranking' },
  { id: 11, label: '宅男观影清单', heat: '🆕 16.3万关注', href: '#ranking' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">热门话题</h2>
        <p className="section-subtitle">大家都在讨论的内容，快速了解当前热度风向</p>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-10 max-w-4xl mx-auto">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}